import type { TFunction } from 'i18next';

import processing_activities_messages from 'messages/processing_activities_messages';

export type DpiaBadgeStyleClasses = {
  dpiaBadgeDanger: string;
  dpiaBadgeInfo: string;
  dpiaBadgeSuccess: string;
  dpiaBadgeWarn: string;
};

export type DpiaDisplayStatusSourceDto = {
  dpia_display_status?: string;
  dpia_indication_status?: string;
};

export const resolveDpiaDisplayStatus = (dto: DpiaDisplayStatusSourceDto): string => {
  if (typeof dto.dpia_display_status === 'string' && dto.dpia_display_status) {
    return dto.dpia_display_status;
  }

  if (dto.dpia_indication_status === 'not_indicated') {
    return 'not_indicated';
  }

  if (dto.dpia_indication_status === 'indicated') {
    return 'indicated';
  }

  return '';
};

export const getDpiaBadgeClass = (status: string, styles: DpiaBadgeStyleClasses) => {
  if (['indicated', 'required', 'dpia_required'].includes(status)) {
    return styles.dpiaBadgeDanger;
  }

  if (['ready_for_review', 'in_progress', 'clarification_requested'].includes(status)) {
    return styles.dpiaBadgeWarn;
  }

  if (['approved', 'not_required', 'dpia_not_required', 'not_indicated'].includes(status)) {
    return styles.dpiaBadgeSuccess;
  }

  return styles.dpiaBadgeInfo;
};

export const getDpiaLabel = (status: string, t: TFunction) => {
  const messageMap = processing_activities_messages.asset_ropa.dpia_status as Record<string, string[]>;
  const message = messageMap[status];
  return message ? t(message) : status.replace(/_/g, ' ');
};
